export const toDecimal = (number: number) => number / 100

export const toTwoDecimals = (number: number) => parseFloat(number?.toFixed(2))

export const toZeroDecimals = (number: number) => parseFloat(number?.toFixed(0))
